import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'aura-button-card',
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './button-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonCardComponent {
  label = input.required<string>();
  selected = input<boolean>(false);
  clicked = output<void>();

  onClick() {
    this.clicked.emit();
  }
}
